import * as React from "react";
import { Button, Divider, Grid, Tab, Segment } from "semantic-ui-react";

import { Detail } from "@neworbit/simpleui-detail";

import { getYesNoOptionEnabledDisplayValue } from "@teamprevent/common/model";

import { CoreDetailProps, DetailProps } from "../Detail";
import DeleteButton from "../DeleteButton";
import { ADMIN_ROLES, Authorize } from "../../../../auth";

import { CoreDetailsButtons } from "./CoreDetailButtons";

import { Link } from "redux-little-router";

export const CoreDetails: React.SFC<CoreDetailProps> = (props) => (
    <Grid>
        <Detail label="Name" value={props.customerDocument.name} labelWidth={5} valueWidth={11} />
        <Detail label="Description" value={props.customerDocument.description} labelWidth={5} valueWidth={11} />
        <Grid.Row>
            <Grid.Column width={5} as="h4">
                Url
            </Grid.Column>
            <Grid.Column width={11} as="h4">
                {props.customerDocument.url &&
                    <a
                        href={props.customerDocument.url}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {props.customerDocument.url}
                    </a>
                }
            </Grid.Column>
        </Grid.Row>
        <Grid.Row>
            <Grid.Column width={5} as="h4">
                Document
            </Grid.Column>
            <Grid.Column width={11} as="h4" className="url">
                {props.customerDocument.fileName && props.customerDocument.blobId &&
                    <a
                        // eslint-disable-next-line max-len
                        href={`/api/customer/${props.customerDocument.customerId}/customerDocument/document/${props.customerDocument.blobId}?fileName=${props.customerDocument.fileName}`}
                    >
                        <Button content={props.customerDocument.fileName} type="button" />
                    </a>
                }
            </Grid.Column>
        </Grid.Row>
        <Detail
            label="Viewable by Manager"
            value={getYesNoOptionEnabledDisplayValue(props.customerDocument.viewableByManager || false)}
            labelWidth={5}
            valueWidth={11}
        />
    </Grid>
);

const CoreDetailsWithActions: React.SFC<DetailProps> = (props) => {
    return (
        <div>
            <CoreDetails customerDocument={props.customerDocument} />

            <Authorize roles={[ADMIN_ROLES.SENIOR_ADMINISTRATOR, ADMIN_ROLES.SYSTEM_ADMIN]}>
                <Divider />
                <Segment basic clearing vertical>
                    <DeleteButton />
                    <CoreDetailsButtons customerDocument={props.customerDocument} />
                    <Button icon="pencil" content="Edit" floated="right" as={Link} href={`${props.path}/edit`} />
                </Segment>
            </Authorize>
        </div>
    );
};

export const coreDetailsTab = (props: DetailProps) => ({
    path: "",
    menuItem: "Details",
    render: () => <Tab.Pane><CoreDetailsWithActions {...props} /></Tab.Pane>
});
